<template>
  <div class="ta flex flex-row">
    <div v-for="(item, index) in lists" :key="index" class="flex-1 ta-item">
      <img :src="$oss(item.img)" class="ta-img" />
      <div>{{ item.subName }}</div>
      <div>{{ item.name }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      lists: [
        {
          subName: "在线咨询",
          name: "专业解答",
          img: "device/device-detail-2.png",
        },
        {
          subName: "在线下单",
          name: "方便快捷",
          img: "device/device-detail-3.png",
        },
        {
          subName: "在线支付",
          name: "安全保障",
          img: "device/device-detail-4.png",
        },
        {
          subName: "实验周期短",
          name: "快速出结果",
          img: "device/device-detail-5.png",
        },
        {
          subName: "在线查看报告",
          name: "随时沟通反馈",
          img: "device/device-detail-6.png",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.ta {
  background: rgba(#7797ff, 0.11);
  padding: 20px 100px;
  &-item {
    text-align: center;
    color: #235ab2;
  }
  &-img {
    width: 70px;
    margin-bottom: 5px;
  }
}
</style>
